module.exports = __webpack_public_path__ + "static/img/m2_t6.3fda0971.jpg";